<template>
  <aside
    v-if="items.length"
    class="ext-sidenav"
  >
    <!-- Report header -->
    <div v-if="title" class="ext-sidenav__report">
      <div class="ext-sidenav__eyebrow">Report</div>
      <div class="ext-sidenav__title">{{ title }}</div>
    </div>

    <!-- Nav items -->
    <nav class="ext-sidenav__nav">
      <div v-for="(item, idx) in items" :key="item.id">
        <button
          class="ext-sidenav__item"
          :class="{ 'is-active': isActive(item) }"
          @click="$emit('select', { type: 'domain', id: item.id })"
        >
          <span class="ext-sidenav__num">{{ String(idx + 1).padStart(2, '0') }}</span>
          <span class="ext-sidenav__label">{{ item.label }}</span>
        </button>

        <!-- Metric children -->
        <div v-if="item.children && item.children.length" class="ext-sidenav__children">
          <button
            v-for="child in item.children"
            :key="child.id"
            class="ext-sidenav__child"
            :class="{ 'is-active': isChildActive(child) }"
            @click="$emit('select', { type: 'metric', id: child.id, parentId: item.id })"
          >
            <span class="ext-sidenav__label">{{ child.label }}</span>
          </button>
        </div>
      </div>
    </nav>

    <!-- Export action -->
    <div v-if="showExport" class="ext-sidenav__footer">
      <button
        class="ext-sidenav__export"
        :disabled="exporting"
        @click="$emit('export')"
      >{{ exporting ? 'Exporting…' : '↓ Export XLSX' }}</button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'ClientSideNav',
  props: {
    title: { type: String, default: '' },
    items: { type: Array, default: () => [] },
    activeDomainId: { type: [String, Number], default: null },
    activeMetricId: { type: [String, Number], default: null },
    showExport: { type: Boolean, default: false },
    exporting: { type: Boolean, default: false },
  },
  emits: ['select', 'export'],
  methods: {
    isActive(item) {
      return (
        this.activeMetricId == null &&
        String(item.id) === String(this.activeDomainId)
      );
    },
    isChildActive(child) {
      return String(child.id) === String(this.activeMetricId);
    },
  },
};
</script>

<style scoped>
.ext-sidenav {
  width: 232px;
  background: #FFFFFF;
  border-right: 1px solid #F2EEE8;
  padding: 18px 12px 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.ext-sidenav__report {
  padding: 0 10px 16px;
  border-bottom: 1px solid #F2EEE8;
  margin-bottom: 14px;
}
.ext-sidenav__eyebrow {
  font-size: 9.5px;
  color: #7D7770;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-weight: 500;
}
.ext-sidenav__title {
  font-size: 16px;
  font-weight: 600;
  color: #0F0D0B;
  margin-top: 2px;
  letter-spacing: -0.01em;
}

.ext-sidenav__nav {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.ext-sidenav__item {
  width: 100%;
  display: grid;
  grid-template-columns: 26px 1fr;
  align-items: center;
  gap: 2px;
  padding: 6px 10px;
  background: transparent;
  border: 0;
  border-radius: 5px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  font-size: 12.5px;
  color: #4A4540;
  transition: all 0.1s;
}
.ext-sidenav__item:hover {
  background: #F9F6F1;
  color: #0F0D0B;
}
.ext-sidenav__item:hover .ext-sidenav__num {
  color: #4A4540;
}
.ext-sidenav__item.is-active {
  background: #0F0D0B;
  color: #FFFFFF;
}
.ext-sidenav__item.is-active .ext-sidenav__num {
  color: #FBAA8C;
}

.ext-sidenav__num {
  font-family: 'JetBrains Mono', 'SF Mono', ui-monospace, monospace;
  font-size: 10px;
  color: #A9A29A;
  font-weight: 500;
}

.ext-sidenav__label {
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ext-sidenav__children {
  margin-left: 2px;
  margin-top: 1px;
  margin-bottom: 4px;
}
.ext-sidenav__child {
  width: 100%;
  display: block;
  padding: 4px 10px 4px 38px;
  background: transparent;
  border: 0;
  border-radius: 5px;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  font-size: 12px;
  color: #7D7770;
  transition: all 0.1s;
}
.ext-sidenav__child:hover {
  background: #F9F6F1;
  color: #0F0D0B;
}
.ext-sidenav__child.is-active {
  background: #0F0D0B;
  color: #FFFFFF;
}
.ext-sidenav__footer {
  margin-top: auto;
  padding: 14px 10px 18px;
  border-top: 1px solid #F2EEE8;
}
.ext-sidenav__export {
  width: 100%;
  padding: 7px 10px;
  font-family: inherit;
  font-size: 11.5px;
  font-weight: 500;
  color: #7D7770;
  background: transparent;
  border: 1px solid #E8E3DC;
  border-radius: 5px;
  cursor: pointer;
  transition: all 0.1s;
}
.ext-sidenav__export:hover {
  background: #F9F6F1;
  color: #0F0D0B;
  border-color: #CFC8BE;
}
.ext-sidenav__export:disabled {
  opacity: 0.5;
  cursor: default;
}
</style>
